import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Button } from 'dw-us-ui';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { EmotionBreakpoint } from 'dw-us-ui';

const ButtonTabsContainer = styled.div`
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
  }
  ${EmotionBreakpoint('mobile')} {
    .back-to-home {
      margin-left: 25px;
    }
  }
  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
  }
  margin: auto;
  text-align: left;
  .button-tab-div {
    border-bottom: 1px solid #ccc;
    width: 100%;
  }
  .button-tab {
    font-size: 16px;
    padding: 10px 28px;
    cursor: pointer;
    opacity: 0.6;
    background: white;
    border-width: 0px 0px 2px;
    border-top-style: initial;
    border-right-style: initial;
    border-left-style: initial;
    border-top-color: initial;
    border-right-color: initial;
    border-left-color: initial;
    border-image: initial;
    outline: 0px;
    border-bottom-style: solid;
    border-bottom-color: transparent;
    transition: border-bottom 250ms ease 0s;
  }
  .icon-size {
    font-size: 17px;
    margin-top: 2px;
  }
  .button-tab:hover {
    border-bottom: ${({ theme }) => `2px solid ${theme.button.primary.backgroundColor}`};
    opacity: 1;
  }
  .active {
    border-bottom: ${({ theme }) => `2px solid ${theme.button.primary.backgroundColor}`};
    opacity: 1;
  }
  .btn-icon {
    display: flex;
    align-items: center;
    gap: 5px;
  }
`;

const ButtonTabs = ({ navTab }) => {
  const history = useHistory();
  const location = useLocation();
  const [activePage, setActivePage] = useState();

  let types = [];
  navTab.length &&
    navTab.forEach(tab => {
      if (tab?.sys?.contentType?.sys?.id === 'link') {
        types.push(tab?.fields);
        if (tab?.fields?.url === location.pathname && activePage !== tab?.fields?.text) {
          setActivePage(tab?.fields?.text);
        }
      }
    });
  const setHistory = (e, type) => {
    setActivePage(type?.text);
    if (type?.url === '/' || type?.url === '/list') {
      history.push(type?.url);
    } else {
      window.location.href = type?.url;
    }
  };

  return (
    <ButtonTabsContainer>
      <div className="button-tab-div">
        {types.map((type, index) => (
          <button
            onClick={e => setHistory(e, type)}
            className={type?.text === activePage ? 'button-tab active' : 'button-tab'}
            key={index}
          >
            {type?.text}
          </button>
        ))}
      </div>
    </ButtonTabsContainer>
  );
};

export { ButtonTabs };
